import React, { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Carousel from "re-carousel";

import Dots from "../../components/Dots";
import SideText from "../../components/SideText";
import SideShape from "../../components/SideShape";
// import SideLogo from '../../components/SideLogo'

import homeLandscape from "../../assets/images/home_landscape.png";
import homePortrait from "../../assets/images/home_portrait.png";
import home2Landscape from "../../assets/images/home2_landscape.png";
import home2Portrait from "../../assets/images/home2_portrait.png";

import theme from "../../styles/theme";
import { Image } from "./style";

import {
  getEditSetup,
  getStoreId,
  getBanner1Title,
  getBanner1Subtitle,
  getBanner2Title,
  getBanner2Subtitle
} from "../../services/auth";

const Home = () => {
  let history = useHistory();

  if (!getStoreId() || getEditSetup() === "true") history.push("/setup");

  const handleClick = useCallback(() => {
    history.push("/categories");
  }, [history]);

  useEffect(() => {
    var viewportmeta = document.querySelector('meta[name="viewport"]');

    if (viewportmeta) {
      viewportmeta.content =
        "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0, user-scalable=no";
    }

    return () => {
      viewportmeta.content = "width=device-width, initial-scale=1";
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  const onCarouselTransitionEnd = ({ current, prev, next }) => {
    const prevGreenContainer = prev && prev.querySelector(".background-color");
    const nextGreenContainer = next && next.querySelector(".background-color");
    const currentGreenContainer =
      current && current.querySelector(".background-color");

    const prevLineCarousel = prev && prev.querySelector(".line-carousel");
    const nextLineCarousel = next && next.querySelector(".line-carousel");
    const currentLineCarousel =
      current && current.querySelector(".line-carousel");

    const prevToqueDescubraMais = prev && [
      ...prev.querySelectorAll(".find-more")
    ];
    const nextToqueDescubraMais = next && [
      ...next.querySelectorAll(".find-more")
    ];
    const currentToqueDescubraMais = current && [
      ...current.querySelectorAll(".find-more")
    ];

    const prevTitleContent = prev && prev.querySelector(".title-content");
    const nextTitleContent = next && next.querySelector(".title-content");
    const currentTitleContent =
      current && current.querySelector(".title-content");

    const prevText = prev && [...prev.querySelectorAll(".fade-in")];
    const nextText = next && [...next.querySelectorAll(".fade-in")];
    const currentText = current && [...current.querySelectorAll(".fade-in")];

    if (prev) {
      prevGreenContainer.style.animationName = "";
      prevGreenContainer.style.opacity = 0;
      prevLineCarousel.style.animationName = "";
      prevLineCarousel.style.opacity = 0;
      prevToqueDescubraMais.map(el => {
        el.style.animationName = "";
        el.style.opacity = 0;
      });
      prevTitleContent.style.animationName = "";
      prevText.map(el => {
        el.style.animationName = "";
        el.style.opacity = 0;
      });
    }

    if (next) {
      nextGreenContainer.style.animationName = "";
      nextGreenContainer.style.opacity = 0;
      nextLineCarousel.style.animationName = "";
      nextLineCarousel.style.opacity = 0;
      nextToqueDescubraMais.map(el => {
        el.style.animationName = "";
        el.style.opacity = 0;
      });
      nextTitleContent.style.animationName = "";
      nextText.map(el => {
        el.style.animationName = "";
        el.style.opacity = 0;
      });
    }

    if (current) {
      currentGreenContainer.style.animationName = "slideinbackground";
      currentGreenContainer.style.opacity = 1;
      currentLineCarousel.style.animationName = "slidein";
      currentLineCarousel.style.opacity = 1;
      currentToqueDescubraMais.map(el => {
        el.style.animationName = "slideinTriangle";
        el.style.opacity = 1;
      });
      currentTitleContent.style.animationName = "slidein";
      currentText.map(el => {
        el.style.animationName = "opacityIn";
        el.style.opacity = 1;
      });
    }
  };

  return (
    <Carousel
      auto
      loop
      widgets={[Dots]}
      onTransitionEnd={onCarouselTransitionEnd}
    >
      <Image src={[homeLandscape, homePortrait]}>
        <div className="background-color" style={{ animationDuration: "1s" }} />
        <div>
          <SideText
            width={"100%"}
            color={"#158110"}
            title={getBanner1Title()}
            subTitle={getBanner1Subtitle()}
            zIndex="1"
          />
          <SideShape />
        </div>
      </Image>
      <Image src={[home2Landscape, home2Portrait]}>
        <div className="background-color" style={{ animationDuration: "1s" }} />
        <div>
          <SideText
            width={"100%"}
            color={theme.red}
            title={getBanner2Title()}
            subTitle={getBanner2Subtitle()}
            zIndex="1"
          />
          <SideShape />
        </div>
      </Image>
    </Carousel>
  );
};

export default Home;
